import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Checklist, PageResponse } from '@app/models';
import { Observable } from 'rxjs';
import { BaseServiceClass } from './baseService.service';

@Injectable({ providedIn: 'root' })
export class ChecklistService extends BaseServiceClass<Checklist> {
  constructor(protected httpService: HttpClient) {
    super(httpService, '/checklists');
  }

  findBySegment(segmentId: number): Observable<Checklist[]> {
    return this.httpService.get<Checklist[]>(
      `${this.entity_url}/segments/${segmentId}`
    );
  }

  public updateActive(id: number, value: boolean) {
    return this.httpService.patch(
      `${this.entity_url}/${id}/active/${value}`,
      null
    );
  }

  public filterChecklist(filter: {
    name?: string;
    segmentsIds?: number[];
    active?: boolean;
  }) {
    return this.httpService.get<Checklist[]>(`${this.entity_url}/filter`, {
      params: filter,
    });
  }

  public filterWithPagination(filter: {
    name?: string;
    segmentIds?: number[];
    active?: boolean;
    page?: number;
    linesPerPage?: number;
    orderBy?: string;
    direction?: string;
    showChecklistItems?: boolean;
    showMultipleChecklist?: boolean;
  }): Observable<PageResponse<Checklist>> {
    return this.filter(filter);
  }
}
